<template>
  <c-box mt="4xl" :mx="{ base: '-30px', sm: '0' }">
    <c-flex align-items="center" mt="4xl" mb="xl" height="16">
      <c-heading
        as="h1"
        color="brand.purpleDark"
        data-cy="list-bulletin-title"
        :ml="{ base: '15px', sm: 0 }"
        >{{ $t("bulletin.listBulletin") }}</c-heading
      >
    </c-flex>
    <router-link
      v-for="item in bulletinList"
      v-chakra
      :key="item.link"
      :to="{ name: 'bulletin', params: { id: item.id } }"
      display="flex"
      mt="3xl"
      background="white"
      maxWidth="4xl"
      :borderRadius="{ base: 'none', sm: 'base' }"
      :boxShadow="{ base: 'none', sm: 'base' }"
      :_hover="{
        textDecoration: 'none',
        color: 'brand.purple',
      }"
    >
      <c-flex
        :flexDirection="{ base: 'column', sm: 'row' }"
        width="100%"
        :padding="{ base: 'md', sm: '2xl' }"
      >
        <c-box
          v-if="item.featured_image_url"
          borderRadius="sharper"
          :style="{ backgroundImage: 'url(' + item.featured_image_url + ')' }"
          backgroundRepeat="no-repeat"
          backgroundPosition="center center"
          backgroundSize="cover"
          width="400px"
          height="200px"
          maxHeight="100%"
          maxWidth="100%"
          :mr="{ base: '0', sm: 'xl' }"
        />
        <c-box>
          <c-text mt="18px" mb="xl" color="brand.purple">{{
            item.date | moment("D.M.YYYY")
          }}</c-text>
          <c-heading as="h2" fontSize="2xl" v-html="item.title" />
        </c-box>
      </c-flex>
    </router-link>
  </c-box>
</template>

<script lang="ts">
import { CBox, CFlex, CHeading, CText } from "@chakra-ui/vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "ListBulletin",
  components: {
    CHeading,
    CText,
    CBox,
    CFlex,
  },

  computed: {
    bulletinList(): any[] {
      return this.$store.state.bulletin.bulletin;
    },
  },
});
</script>
